<template>
    <!-- page content -->
    <div class="right_col" role="main">
        <div class="">
            <div class="page-title">
                <div class="title_left">
                    <h3>Validity Plan</h3>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="col-sm-12">
                <div class="alert alert-info" v-if="alert_message">
                    {{alert_message}}
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-sm-12 ">
                    <div class="x_panel">
                        <div class="x_title">
                            <h2> <span v-if="validityPlans.length >= 0">Total : {{validityPlans.length}}</span></h2>
                            <div class="clearfix"></div>
                        </div>
                        <div class="x_content table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                <tr>
                                    <th class="tdCenter tdSN">SN</th>
                                    <th class="tdCenter">Name</th>
                                    <th class="tdCenter">Days</th>
                                    <th class="tdCenter">{{pinWordReplacementWith}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for='(data, index) in validityPlans'>
                                    <td class="tdCenter tdSN">{{++index}}</td>
                                    <td class="tdCenter">{{data.plan_name}}</td>
                                    <td class="tdCenter">{{data.no_of_days}}</td>
                                    <td class="tdCenter">{{data.price}}</td>
                                </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- /page content -->
</template>
<script>
    export default {
        name: "BaseRatePlan",
        data() {
            return {
                pinWordReplacementWith: process.env.VUE_APP_PIN_WORD_REPLACEMENT_WITH,
                alert_message:'',
                validityPlans: {},
            }
        },
        created() {
            this.com_user_type_access([0, 1], true);
            //loader.show();
            var rootObject = this;
            this.validityPlans =  this.basePrice = this.$store.getters.getValidityPlans;
        },
        methods: {},
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>